import type { Directive, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth'

function matchPermission(userPerm: string, requiredPerm: string): boolean {
  if (userPerm === '*:*') {
    return true
  }
  if (userPerm === requiredPerm) {
    return true
  }
  const userParts = userPerm.split(':')
  const requiredParts = requiredPerm.split(':')
  if (userParts.length !== requiredParts.length) {
    return false
  }
  for (let i = 0; i < userParts.length; i++) {
    if (userParts[i] !== '*' && userParts[i] !== requiredParts[i]) {
      return false
    }
  }
  return true
}

const checkPermission = (el: HTMLElement, binding: DirectiveBinding) => {
  const { value } = binding
  const authStore = useAuthStore()
  const permissions = authStore.user?.permissions || []

  const checkSinglePermission = (requiredPerm: string): boolean => {
    return permissions.some(userPerm => matchPermission(userPerm, requiredPerm))
  }

  if (value && value instanceof Array && value.length > 0) {
    const requiredPermissions = value
    const hasPermission = requiredPermissions.some(p => checkSinglePermission(p))

    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  } else if (typeof value === 'string' && value.length > 0) {
    const hasPermission = checkSinglePermission(value)

    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  }
}

const permission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    if (binding.oldValue !== binding.value) {
      checkPermission(el, binding)
    }
  }
}

export default permission
